<template>
  <div class="main-header">
    <!-- Logo Header -->
    <div class="logo-header" v-bind:data-background-color="headerBackground">
      <router-link to="/dashboard" class="logo">
        <img
          src="/static/img/branding/indiefy-icon-white.png"
          height="60%"
          alt="navbar brand"
          class="navbar-brand d-none d-md-inline"
        />
        <img
          src="/static/img/branding/indiefy-logo-white.png"
          height="90%"
          alt="navbar brand"
          class="navbar-brand d-md-none"
        />
        <!-- <span class="pro badge badge-warning" v-if="user.subscription">PRO</span> -->
      </router-link>
      <button
        class="navbar-toggler sidenav-toggler ml-auto block-mobile"
        type="button"
        data-toggle="collapse"
        data-target="collapse"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon">
          <i class="icon-menu"></i>
        </span>
      </button>
      <button class="topbar-toggler more block-mobile">
        <i class="icon-options-vertical"></i>
      </button>
    </div>
    <!-- End Logo Header -->

    <!-- Navbar Header -->
    <NavigationBar></NavigationBar>
    <!-- End Navbar -->
  </div>
</template>
<script>
import NavigationBar from './NavigationBar.vue'

export default {
  name: 'Header',
  data: function () {
    return {
      isMobileApp: navigator.userAgent.indexOf('gonative') >= 0,
      headerBackground: 'purple2',
      user: {}
    }
  },
  components: {
    NavigationBar
  },
  mounted: function () {
    window['initSidebar']()
  },
  created: function () {
    this.user = this.$user

    if (this.user.subscription) {
      if (this.user.subscription.plan_name === 'indiefy_lite') {
        this.headerBackground = 'light-blue2'
      } else {
        this.headerBackground = 'dark2'
      }
    }

    this.$eventBus.$on('updateUser', user => {
      this.user = user
    })
  }
}
</script>
<style lang="scss" scoped>
.block-desktop{
  display: none;
}

.block-mobile{
  display: block;
}

@media screen and (min-width: 991px) {
  .block-desktop{
    display: block;
  }

  .block-mobile{
    display: none;
  }
}

.logo-header {
  position: relative;
}

.pro {
  font-size: 11px;
  font-weight: bold;
  padding: 4px 6px;
  top: 21px;
  position: absolute;
  left: 123px;
  background: #2d3548;
}
</style>



// WEBPACK FOOTER //
// src/components/Header.vue